export default "__VITE_ASSET__D7iQ0ch3__"